import React, { Component } from 'react'
import _ from 'lodash'
import moment from 'moment'
import prior_appointment from './../../../../include/pdf/prior_appointment.pdf'
import TermTemplatePopup from '../../../common/termTemplatePopup'
import { toast } from 'react-toastify'
import { Modal } from 'react-bootstrap'
import AlertSuccess from '../../../common/alertSuccess'
import AlertError from '../../../common/alertError'
import { loadTermTemplate } from '../../../../store/seo'
import { connect } from 'react-redux'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import { cancellAppointment, getAppointment, loadDate } from '../../../../store/appointment'

class DateTimeSelection extends Component {
  state = { 
    popShow: false,
    showDatePicker: false,
    selectedPickerDate: new Date().toISOString().slice(0, 10),
    popUp: false, 
  }

  togglePopShow = () => {
    this.setState({ popShow: !this.state.popShow })
  }

  togglePopup = (e) => {
    if (e) e.preventDefault();
    this.setState({ popUp: !this.state.popUp })
  }

  cancellAppointment = e => {
    e.preventDefault()
    this.props.cancellAppointment(
      this.props.appointId,
      this.callBack
    )
  }
  callBack = res => {
    this.togglePopup()
    this.props.removeBodyClass()
    if (res.status === 200) {
      toast(<AlertSuccess message={'Appointment cancelled successfully'} />)
    } else {
      toast(<AlertError message={res.data.error} />)
    }
  }

  openPopup = (e, key) => {
    e.preventDefault()
    this.props.loadTermTemplate(key)
    this.togglePopShow()
  }

  formatAMPM(date) {
    var hours = new moment(date, 'HH').utc().hour() // date.getHours();
    var minutes = new moment(date, 'mm').utc().minutes() //date.getMinutes();
    var ampm = hours >= 12 ? 'PM' : 'AM'
    hours = hours % 12
    hours = hours ? hours : 12 // the hour '0' should be '12'
    minutes = minutes < 10 ? '0' + minutes : minutes
    var strTime = hours + ':' + minutes + ' ' + ampm
    return strTime
  }
componentDidUpdate(prevProps) {
  const doctor = this.props.getDoctor?.doctors?.data[0];
  const clinic1Available = doctor?.clinic_details?.address;
  const clinic2Available = doctor?.clinic_details_2?.address;

  if (
    prevProps.getDoctor !== this.props.getDoctor &&
    !this.props.selectedClinic
  ) {
    if (clinic1Available && !clinic2Available) {
      this.props.changeClinic(1);
    } else if (!clinic1Available && clinic2Available) {
      this.props.changeClinic(2);
    }
  }
  const schedule = doctor?.schedules;

  let availableDurations = [];

  const addIfValid = (fee, time) => {
    if (schedule?.[fee] && schedule?.[time]) {
      availableDurations.push(schedule[time]);
    }
  };

  if (this.props.apType === 'online') {
    addIfValid('onlineFee', 'time');
    addIfValid('onlineFeeSlot2', 'time2');
  }

  if (this.props.apType === 'clinic') {
    if (this.props.selectedClinic === 1) {
      addIfValid('clinicFee', 'time');
      addIfValid('clinicFeeSlot2', 'time2');
    }

    if (this.props.selectedClinic === 2) {
      addIfValid('clinic2Fee', 'time');
      addIfValid('clinic2FeeSlot2', 'time2');
    }
  }

  availableDurations.sort((a, b) => Number(a) - Number(b));

  const defaultDuration = availableDurations.length > 0 ? availableDurations[0] : null;

  if (
    this.props.selectedDate &&
    !this.props.selectedDuration &&
    defaultDuration
  ) {
    this.props.changeDuration(defaultDuration);
  }
}

  render() {
    const doctor = this.props.getDoctor?.doctors?.data[0];
    const clinic1Available = doctor?.clinic_details?.address;
    const clinic2Available = doctor?.clinic_details_2?.address;
    const totalClinics = (clinic1Available ? 1 : 0) + (clinic2Available ? 1 : 0);

    const schedule = doctor?.schedules;

    let durations = [];
    const addIfValid = (fee, time) => {
      if (schedule?.[fee] && schedule?.[time]) {
        durations.push(schedule[time]);
      }
    };

    if (this.props.apType === 'online') {
      addIfValid('onlineFee', 'time');
      addIfValid('onlineFeeSlot2', 'time2');
    }

    if (this.props.apType === 'clinic') {
      if (this.props.selectedClinic === 1) {
        addIfValid('clinicFee', 'time');
        addIfValid('clinicFeeSlot2', 'time2');
      }

      if (this.props.selectedClinic === 2) {
        addIfValid('clinic2Fee', 'time');
        addIfValid('clinic2FeeSlot2', 'time2');
      }
    }

    const getFeeByDuration = (duration) => {
      if (!schedule) return null;

      if (this.props.apType === 'online') {
        if (duration === schedule.time) return schedule.onlineFee;
        if (duration === schedule.time2) return schedule.onlineFeeSlot2;
      }

      if (this.props.apType === 'clinic') {
        if (this.props.selectedClinic === 1) {
          if (duration === schedule.time) return schedule.clinicFee;
          if (duration === schedule.time2) return schedule.clinicFeeSlot2;
        }

        if (this.props.selectedClinic === 2) {
          if (duration === schedule.time) return schedule.clinic2Fee;
          if (duration === schedule.time2) return schedule.clinic2FeeSlot2;
        }
      }

      return null;
    };

    const isClinicSelected =
    this.props.apType === "clinic"
      ? !!this.props.selectedClinic
      : true;

    return (
      <div className="tab-content" id="myTabContent">
        <div
          className="tab-pane fade show active"
          id="pane-tab-e"
          role="tabpanel"
          aria-labelledby="tab-e"
        >
          {this.props.getDoctor.doctors.data.length > 0 && (
            <div className="pane-content-box">
              {this.props.apType === 'clinic' && (
                <>
                  <h4 className="mb-3">Choose Clinic</h4>

                  <div className="row custom-radio-outer">
                    
                    {/* Clinic A */}
                    {clinic1Available && (
                      <div className="col-md-6 mb-3">
                        <div className="custom-control custom-radio clinic-box">
                          <input
                            type="radio"
                            className="custom-control-input"
                            id="clinicA"
                            name="clinic"
                            value={1}
                            checked={this.props.selectedClinic === 1}
                            disabled={!!this.props.appointId}
                            onChange={() => this.props.changeClinic(1)}
                          />

                          <label className="custom-control-label w-100 h-100 clinic-card" htmlFor="clinicA">
                            {totalClinics === 2 && (
                              <i className="fa-duotone fa-solid fa-circle-1 fa-sm clinic-number-icon"></i>
                            )}
                            <span className="clinic-title">CLINIC ADDRESS</span>

                            <div className="clinic-info d-flex">
                              <i className="fa-sharp fa-light fa-location-dot location-icon fa-2xs pt-2"></i>

                              <div className="clinic-cont">
                                <div className="clinic-name">
                                  {doctor?.clinic_details?.name}
                                </div>

                                <div className="clinic-address">
                                  {doctor?.clinic_details?.address}
                                </div>
                                <div className="clinic-address">
                                  {doctor?.clinic_details?.city}, {doctor?.clinic_details?.state}
                                </div>
                              </div>
                            </div>
                          </label>
                        </div>
                      </div>
                    )}

                    {/* Clinic B */}
                    {clinic2Available && (
                      <div className="col-md-6 mb-3">
                        <div className="custom-control custom-radio clinic-box">
                          <input
                            type="radio"
                            className="custom-control-input"
                            id="clinicB"
                            name="clinic"
                            value={2}
                            checked={this.props.selectedClinic === 2}
                            disabled={!!this.props.appointId}
                            onChange={() => this.props.changeClinic(2)}
                          />

                          <label className="custom-control-label w-100 h-100 clinic-card" htmlFor="clinicB">
                            {totalClinics === 2 && (
                              <i className="fa-duotone fa-solid fa-circle-2 fa-sm clinic-number-icon"></i>
                            )}
                            <span className="clinic-title">CLINIC ADDRESS</span>
                            <div className="clinic-info d-flex">
                              <i className="fa-sharp fa-light fa-location-dot location-icon fa-2xs pt-2"></i>

                              <div className="clinic-cont">
                                <div className="clinic-name">
                                  {doctor?.clinic_details_2?.name}
                                </div>

                                <div className="clinic-address">
                                  {doctor?.clinic_details_2?.address}
                                </div>
                                <div className="clinic-address">
                                  {doctor?.clinic_details_2?.city}, {doctor?.clinic_details_2?.state}
                                </div>
                              </div>
                            </div>
                          </label>
                        </div>
                      </div>
                    )}

                  </div>
                  {this.props.appointId && (
                    <p style={{
                        color: "#636161ff",
                        fontSize: "13px",
                        fontWeight: 600
                    }}>
                      (Clinic can't be changed. If you want to change it, you may click here to
                      {' '}
                        <a href="" style={{color: '#621ec0', textDecoration: 'underline'}} onClick={e => {
                          this.togglePopup(e)
                        }}>cancel</a>
                      {' '} and book again.
                      )
                    </p>
                  )}
                </>
              )}
              <div className="d-flex align-items-center justify-content-between" style={{ position: 'relative' }}>
                <h4 className="mb-0">Select Date</h4>
                <button
                  disabled={!isClinicSelected} 
                  className="btn btn-light btn-sm ml-2"
                  onClick={() => this.setState({ showDatePicker: !this.state.showDatePicker })}
                  style={{ border: 'none', background: 'transparent' }}
                >
                  <img
                    src="/calendar-days-solid.svg" 
                    alt="Calendar Icon"
                    style={{ width: '24px', height: '24px' }}
                  />
                </button>
                {this.state.showDatePicker && (
                  <div style={{ position: 'absolute', top: '100%', right: 0, zIndex: 10 }}>
                    <DatePicker
                      selected={this.state.selectedPickerDate}
                      onChange={(date) => {
                        this.setState({ selectedPickerDate: date.toISOString().slice(0, 10), showDatePicker: false })
                        console.log("startDate: date.toISOString() : ",{startDate: date.toISOString().slice(0, 10)})
                        this.props.loadDate({ startDate: date.toISOString().slice(0, 10) })
                        this.props.selectDate(this.props.apType, date.toISOString().slice(0, 10))
                      }}
                      inline
                      minDate={new Date()}
                    />
                  </div>
                )}
              </div>
              <small className='text-muted'>Indian Standard Time (IST)</small>


              <div className="custom-radio-group d-flex date-slot-parent">
                {this.props.getAppointment.dates.map((dv, i) => (
                  <div className="custom-control custom-radio">
                    <input
                      type="radio"
                      className="custom-control-input"
                      id={dv.date}
                      name="radio1"
                      checked={this.props.selectedDate === dv.date}
                      disabled={!isClinicSelected} 
                      onChange={(e) => {
                        if (!isClinicSelected) return;
                        e.preventDefault()
                        this.props.selectDate(this.props.apType, dv.date)
                      }}
                    />
                    <label className="custom-control-label" htmlFor={dv.date}>
                      <p>{dv.day.sortName}</p>
                      <h4>
                        {new Date(dv.date).getDate() +
                          ' ' +
                          this.props.months[new Date(dv.date).getMonth()]}
                      </h4>
                    </label>
                  </div>
                ))}
              </div>
            </div>
          )}
          <div className="time-duration mb-3">
            {this.props.selectedDate && (
            <>
              <h4>Select Duration</h4>
              <div className="custom-radio-group slot-radio-group d-flex flex-wrap">
                {durations.map((duration, index) => {
                  const fee = getFeeByDuration(duration)

                  return (
                    <>
                    <div key={index} className="custom-control custom-radio">
                      <input
                        type="radio"
                        className="custom-control-input"
                        id={`duration-${duration}`}
                        name="selectedDuration"
                        value={duration}
                        checked={this.props.selectedDuration === duration}
                        disabled={!!this.props.appointId}
                        onChange={() => this.props.changeDuration(duration)}
                      />
                      <label
                        className="custom-control-label duration-label"
                        htmlFor={`duration-${duration}`}>
                        <span>{duration} Mins</span>
                        {this.props.selectedDuration !== duration && fee && (
                          <small className="duration-fee">
                            ₹ {fee}
                          </small>
                        )}
                      </label>
                      {this.props.selectedDuration === duration && fee && (
                        <div className="duration-fee">
                          ₹ {fee}
                        </div>
                      )}
                    </div>
                    </>
                  );
                })}
              </div>
              {this.props.appointId && (
                <p style={{
                    color: "#636161ff",
                    fontSize: "13px",
                    fontWeight: 600
                }}>
                  (Duration can't be changed for an existing appointment.)
                </p>
              )}
            </>
            )}
          </div> 
          <div className="pane-content-box">
            <>
              {this.props.getAppointment.loadingSlots ? (
                <h4>Loading ....</h4>
              ) : (
                <>
                  <h4>
                    {this.props.selectedDate &&
                      (this.props.getAppointment.slots.length
                        ? 'Select time slot'
                        : 'Not Available!')}
                  </h4>
                  <div className="custom-radio-group slot-radio-group d-flex flex-wrap">
                    {_.uniqBy(this.props.getAppointment.slots, 'start').map(
                      (vs) => (
                        <div className="custom-control custom-radio">
                          <input
                            disabled={!vs.is_available}
                            type="radio"
                            className="custom-control-input"
                            id={vs.start}
                            name={vs.start}
                            checked={this.props.selectedTime === vs.start}
                            onChange={() => this.props.changeTime(vs.start)}
                          />
                          <label
                            className={
                              vs.is_available
                                ? 'custom-control-label'
                                : 'custom-control-label disabled-slot'
                            }
                            htmlFor={vs.start}
                          >
                            {this.formatAMPM(new Date(vs.start))}
                          </label>
                        </div>
                      ),
                    )}
                  </div>
                </>
              )}
            </>
          </div>{' '}
          {!this.props.appointId && (
            <>
              <h4 className="your-selection mb-0 ">Your Selection</h4>
              <div className="journey-tracker d-flex align-items-center justify-content-center mb-4">
                {[
                  { 
                    step: 1, 
                    title: 'Mode', 
                    value: this.props.apType ? this.props.apType.charAt(0).toUpperCase() + this.props.apType.slice(1) : '',
                    completed: this.props.apType === "clinic"
                      ? !!this.props.selectedClinic
                      : this.props.apType !== ''  
                  },
                  { 
                    step: 2, 
                    title: 'Date', 
                    value: this.props.selectedDate ? moment(this.props.selectedDate).format("DD MMM") : '',
                    completed: this.props.selectedDate !== '' 
                  },
                  { 
                    step: 3, 
                    title: 'Duration', 
                    value: this.props.selectedDuration ? `${this.props.selectedDuration} min` : '',
                    completed: this.props.selectedDuration !== '' 
                  },
                  { 
                    step: 4, 
                    title: 'Time', 
                    value: this.props.selectedTime ? this.formatAMPM(new Date(this.props.selectedTime))  : '',
                    completed: this.props.selectedTime !== '' 
                  },
                ].map((item, index, arr) => (
                  <div key={item.step} className="step-wrapper d-flex align-items-center">

                    {/* Circle and Label */}
                    <div className="circle-wrapper d-flex flex-column align-items-center">
                      <div className={`step-circle ${item.completed ? 'completed' : ''}`}>
                        {item.completed ? '✔' : item.step}
                      </div>
                      <span className="step-label">{`${item.completed ? item.value : item.title}`}</span>
                    </div>

                    {/* Line */}
                    {index !== arr.length - 1 && (
                      <>
                      <div className={`step-line ${arr[index].completed ? 'completed' : ''}`} />
                    </>)}
                  </div>
                ))}
              </div>
            </>
          )}
          <div className="pane-btn">
            <button
              disabled={
                this.props.selectedDate === '' ||
                this.props.selectedTime === '' ||
                this.props.loading
              }
              onClick={() => this.props.doSubmit(this.props.apType)}
              className={
                this.props.selectedDate !== '' &&
                this.props.selectedTime !== '' &&
                !this.props.loading
                  ? 'btn btn-primary'
                  : 'btn btn-primary disabled'
              }
            >
              Proceed
            </button>
          </div>
        </div>
        <div
          class="mr-bottom"
          style={{ position: 'relative', padding: '35px 0px 0px !important' }}
        >
          <p>
            By clicking proceed, I agree to{' '}
            <a href="" onClick={(e) => this.openPopup(e, 'PatientTerms')}>
              terms of service
            </a>{' '}
            and{' '}
            <a
              onClick={(e) => this.openPopup(e, 'user-privacy-policy')}
              href=""
            >
              privacy policy.
            </a>
          </p>
        </div>
        <TermTemplatePopup
          show={this.state.popShow}
          toggle={this.togglePopShow}
        />
        <Modal
          className='modal fade custom-modal'
          show={this.state.popUp}
          onHide={this.togglePopup}>
          <div class='modal-body'>
            <h6>Are you sure you want to Cancel the Appointment?</h6>
            <div class='custom-modal-btn'>
              <a
                href='#!'
                class={'btn btn-outline btn-block'}
                onClick={e => this.cancellAppointment(e)}>
                Yes
              </a>
              <a href='#!' class='btn btn-primary btn-block' onClick={this.togglePopup}>
                No
              </a>
            </div>
          </div>
        </Modal>
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch) => ({
  loadTermTemplate: (key) => dispatch(loadTermTemplate(key)),
  loadDate: (payload) => dispatch(loadDate(payload)),
  cancellAppointment: (id, callBack) =>
    dispatch(cancellAppointment(id, callBack)),
})
export default connect(null, mapDispatchToProps)(DateTimeSelection)
